/** @jsx jsx */
import React from 'react';
import { css, jsx } from '@compiled/react';
import { AppSkeletonImage } from '@jira/platform__skeleton-image-container/src/ui/AppSkeletonImage.tsx';
import imgSVG from './assets/getting-started-page-app-skeleton.tpl.svg';

const customCssStyles = css({
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
	'&&': {
		margin: 'auto',
		minWidth: '760px',
		maxWidth: '1174px',
	},
});

export const GettingStartedPageSkeleton = () => (
	<AppSkeletonImage src={imgSVG} css={customCssStyles} />
);
